import React, { useEffect, useState } from 'react'
import { Button, Icon, Image, Menu, Sidebar, Dropdown } from 'semantic-ui-react'
import { Link } from 'react-router'
import leftLogo from '../../../../addons/images/EUI.png'
import rightLogo from '../../../../addons/images/BRaVE-colors.png'
import PropTypes from 'prop-types'
import { paths } from '../../paths'

const hamburgerMenu = (props) => {
  const [isShowedMenuAbout, showMenuAbout] = useState(false)

  useEffect(() => {
    props.getSubheaderName()
  }, [])

  const handleItemClick = (e, name) => {
    props.getSubheaderName(name)
  }

  const activeItem = props.name

  const returnAbout = (
    <React.Fragment>
      <Dropdown
        text='ABOUT'
        item
        onMouseOver={() => showMenuAbout(true)}
        onMouseOut={() => showMenuAbout(false)}
        />
      <Menu.Item
        name='ABOUT BRAVE'
        style={{ display: isShowedMenuAbout ? 'block' : 'none' }}
        active={activeItem === 'aboutBrave'}
        as={Link}
        to={'/about/aboutBrave'}
        onMouseOver={() => showMenuAbout(true)}
        onMouseOut={() => showMenuAbout(false)}
        />
      <Menu.Item
        name='CONSORTIUM'
        style={{ display: isShowedMenuAbout ? 'block' : 'none' }}
        active={activeItem === 'consortium'}
        as={Link}
        to={'/about/consortium'}
        onMouseOver={() => showMenuAbout(true)}
        onMouseOut={() => showMenuAbout(false)}
        />
      <Menu.Item
        name='ADVISORY BOARD'
        style={{ display: isShowedMenuAbout ? 'block' : 'none' }}
        active={activeItem === 'advisoryBoard'}
        as={Link}
        to={'/about/advisoryBoard'}
        onMouseOver={() => showMenuAbout(true)}
        onMouseOut={() => showMenuAbout(false)}
        />
    </React.Fragment>
  )
  return (
    <Sidebar.Pushable>
      <Sidebar
            as={Menu}
            animation='overlay'
            icon='labeled'
            onHide={() => props.toggle(!props.menuToggle)}
            vertical
            visible={props.menuToggle}
            width='thin'
          >
        {paths.map((path, i) => path.name !== 'ABOUT'
          ? <Menu.Item
              key={i}
              name={path.name}
              as={Link}
              to={!path.disabled && path.to}
              active={activeItem === path.active}
              disabled={path.disabled}
              onClick={() => handleItemClick(path.onClick)}
              />
          : returnAbout
              )}
      </Sidebar>
      <Sidebar.Pusher dimmed={props.menuToggle}>
        <div className='MainMenu' style={{ flexWrap: 'wrap' }}>
          <Image className='LeftLogo' src={leftLogo} />
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <Link to='/'><Image className='RightLogo' src={rightLogo} style={{ marginRight: 20 }}/></Link>
            <Button
              icon
              onClick={() => props.toggle(!props.menuToggle)}
              size='big'
              style={{ backgroundColor: 'white', boxShadow: 'none', padding: 5, paddingBottom: 18 }}>
              {props.menuToggle
                    ? <Icon name='close' size='big' style={{ color: '#247F7B' }} />
                    : <Icon name='bars' size='big' style={{ color: '#247F7B' }}/>}
            </Button>
          </div>
        </div>
        {props.children}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  )
}

hamburgerMenu.propTypes = {
  menuToggle: PropTypes.bool,
  toggle: PropTypes.func,
  getSubheaderName: PropTypes.func,
  name: PropTypes.string,
  children: PropTypes.any
}

export default hamburgerMenu



// WEBPACK FOOTER //
// ./src/layouts/Layout/HamburgerMenu/components/HamburgerMenu.js